module.exports = __webpack_public_path__ + "img/footer-logo .e85b36e5.png";